module.exports = __webpack_public_path__ + "img/vgb.b37358a1.svg";